// located in client/@types/styled-components
import { DefaultTheme } from 'styled-components';
import { DEFAULT_THEME, THEME_1, THEME_2, THEME_3 } from 'App/constants';

/** *************************************************************
 *                          Theme 1
 ************************************************************* */

export const theme1: DefaultTheme = {
  background: '#f7f7f8',

  textColor: '#5a5a5a',
  textColorHeading: '#434343',

  highlightedColor: '#4a56e4',
  highlightedColor2: '#973cc1',

  showImageBackgroundColor: '#e1e1e4',

  trackPlayedColor: '#4a56e4',
  trackUnplayedColor: '#e1e1e4',

  nextTrackButtonColor: '#878a92',
  get nextTrackButtonHoverColor() {
    return this.highlightedColor;
  },
  prevTrackButtonColor: '#878a92',
  get prevTrackButtonHoverColor() {
    return this.highlightedColor;
  },

  currentlyPlayingTrackBackgroundColor: '#fff',
  get currentlyPlayingTrackColor() {
    return this.highlightedColor;
  },

  tooltipBackground: '#fff',
  tooltipShadowColor: 'rgba(196, 196, 196, 1)',

  playedDurationColor: '#969799',
  get playedDurationColorHovered() {
    return this.highlightedColor;
  },

  thumbDefaultFill: '#f7f7f8',
  get thumbDefaultStroke() {
    return this.highlightedColor;
  },
  thumbHoveredFill: '#f7f7f8',
  thumbHoveredStroke: '#4a56e4',
  get thumbTooltipColor() {
    return this.highlightedColor;
  },

  logoFill: '#6141df',

  get scrollbarBackgroundColor() {
    return this.background;
  },
  scrollbarThumbBackgroundColor: '#c4c4c4',
  scrollbarThumbBackgroundColorHover: '#C4C5C6',

  spinnerBackgroundColor: '#e1e1e4',
  spinnerSpinColor: '#878a92',

  get reloadButtonBackgroundColor() {
    return this.highlightedColor;
  },
  get reloadButtonBackgroundColorHovered() {
    return this.logoFill;
  },
  get reloadButtonColor() {
    return this.background;
  },
  // Color of error message shown in playlist when showApiRequst fails
  get errorMessageColor() {
    return this.textColor;
  },

  get footerBackgroundColor() {
    return this.background;
  },

  headerShadowColor: 'rgba(0, 0, 0, 0.05)',
  footerBoxShadowColor: 'rgba(0, 0, 0, 0.1)',
};

/** *************************************************************
 *                          Theme 2
 ************************************************************* */

export const theme2: DefaultTheme = {
  background: 'linear-gradient(to right, #4a56e4 0%,#6e41e0 100%)',

  textColor: '#fff',
  textColorHeading: '#fff',

  highlightedColor: '#4a56e4',
  highlightedColor2: '#6e41e0',

  showImageBackgroundColor: '#3c46bd',

  trackPlayedColor: '#fff',
  trackUnplayedColor: '#825ee5',

  nextTrackButtonColor: '#d6d2f8',
  nextTrackButtonHoverColor: '#fff',
  prevTrackButtonColor: '#d6d2f8',
  prevTrackButtonHoverColor: '#fff',

  currentlyPlayingTrackBackgroundColor: 'rgba(255,255,255,.2)',
  currentlyPlayingTrackColor: '#fff',

  tooltipBackground: 'linear-gradient(to right, #4a56e4 0%,#6e41e0 100%)',
  tooltipShadowColor: ' rgb(62, 62, 62)',

  playedDurationColor: '#cdc2f3',
  playedDurationColorHovered: '#fff',

  get thumbDefaultFill() {
    return this.highlightedColor;
  },
  thumbDefaultStroke: '#f7f7f8',
  thumbHoveredFill: '#4a56e4',
  thumbHoveredStroke: '#f7f7f8',
  get thumbTooltipColor() {
    return this.highlightedColor;
  },

  logoFill: '#fff',

  get scrollbarBackgroundColor() {
    return this.highlightedColor2;
  },
  scrollbarThumbBackgroundColor: '#c4c4c4',
  get scrollbarThumbBackgroundColorHover() {
    return '#fff';
  },

  spinnerBackgroundColor: 'rgba(255, 255, 255, 0.2)',
  spinnerSpinColor: '#fff',

  reloadButtonBackgroundColor: '#fff',
  get reloadButtonBackgroundColorHovered() {
    return this.prevTrackButtonColor;
  },
  get reloadButtonColor() {
    return this.highlightedColor;
  },
  get errorMessageColor() {
    return this.textColor;
  },

  get footerBackgroundColor() {
    return this.background;
  },

  headerShadowColor: 'rgba(255, 255, 255, 0.05)',
  footerBoxShadowColor: 'rgba(255, 255, 255, 0.1)',
};

/** *************************************************************
 *                          Theme 3
 ************************************************************* */

export const theme3: DefaultTheme = {
  background: '#34383c',

  textColor: '#fff',
  textColorHeading: '#fff',

  highlightedColor: '#4a56e4',
  highlightedColor2: '#6e41e0',

  showImageBackgroundColor: '#ffcf03',

  trackPlayedColor: '#fff',
  trackUnplayedColor: '#525659',

  nextTrackButtonColor: 'rgba(255, 255, 255, .7)',
  nextTrackButtonHoverColor: 'rgba(255, 255, 255, 1)',
  prevTrackButtonColor: 'rgba(255, 255, 255, .7)',
  prevTrackButtonHoverColor: 'rgba(255, 255, 255, 1)',

  currentlyPlayingTrackBackgroundColor: 'rgba(255,255,255,.2)',
  currentlyPlayingTrackColor: '#fff',

  get tooltipBackground() {
    return this.background;
  },
  tooltipShadowColor: 'grey',

  playedDurationColor: 'rgba(255, 255, 255, .7)',
  playedDurationColorHovered: 'rgba(255, 255, 255, 1)',

  get thumbDefaultFill() {
    return this.background;
  },
  thumbDefaultStroke: '#f7f7f8',
  get thumbHoveredFill() {
    return this.background;
  },
  thumbHoveredStroke: '#f7f7f8',
  get thumbTooltipColor() {
    return this.background;
  },

  logoFill: '#fff',

  get scrollbarBackgroundColor() {
    return this.background;
  },
  scrollbarThumbBackgroundColor: '#c4c4c4',
  get scrollbarThumbBackgroundColorHover() {
    return '#fff';
  },

  spinnerBackgroundColor: 'rgba(255, 255, 255, 0.2)',
  spinnerSpinColor: '#fff',

  get reloadButtonBackgroundColor() {
    return this.showImageBackgroundColor;
  },
  get reloadButtonBackgroundColorHovered() {
    return this.thumbDefaultStroke;
  },

  get reloadButtonColor() {
    return this.background;
  },
  get errorMessageColor() {
    return this.textColor;
  },

  get footerBackgroundColor() {
    return this.background;
  },

  headerShadowColor: 'rgba(255, 255, 255, 0.05)',
  footerBoxShadowColor: 'rgba(255, 255, 255, 0.1)',
};

export const themes = {
  [DEFAULT_THEME]: theme1,
  [THEME_1]: theme1,
  [THEME_2]: theme2,
  [THEME_3]: theme3,
};
